export const RESET_ERROR = 'RESET_ERROR';
export const RESET_IMAGES = 'RESET_IMAGES';

export const GET_IMAGE_CONFIGURATION_REQUEST =
  'GET_IMAGE_CONFIGURATION_REQUEST';
export const GET_IMAGE_CONFIGURATION_SUCCESS =
  'GET_IMAGE_CONFIGURATION_SUCCESS';
export const GET_IMAGE_CONFIGURATION_FAILURE =
  'GET_IMAGE_CONFIGURATION_FAILURE';

export const GET_BATCH_ID_REQUEST = 'GET_BATCH_ID_REQUEST';
export const GET_BATCH_ID_SUCCESS = 'GET_BATCH_ID_SUCCESS';
export const GET_BATCH_ID_FAILURE = 'GET_BATCH_ID_FAILURE';

export const GET_BRANDS_REQUEST = 'GET_BRANDS_REQUEST';
export const GET_BRANDS_SUCCESS = 'GET_BRANDS_SUCCESS';
export const GET_BRANDS_FAILURE = 'GET_BRANDS_FAILURE';

export const IMAGE_UPLOAD_REQUEST = 'IMAGE_UPLOAD_REQUEST';
export const IMAGE_UPLOAD_SUCCESS = 'IMAGE_UPLOAD_SUCCESS';
export const IMAGE_UPLOAD_FAILURE = 'IMAGE_UPLOAD_FAILURE';

export const IMAGE_STATUS_REQUEST = 'IMAGE_STATUS_REQUEST';
export const IMAGE_STATUS_SUCCESS = 'IMAGE_STATUS_SUCCESS';
export const IMAGE_STATUS_FAILURE = 'IMAGE_STATUS_FAILURE';

export const BATCH_STATUS_REQUEST = 'BATCH_STATUS_REQUEST';
export const BATCH_STATUS_SUCCESS = 'BATCH_STATUS_SUCCESS';
export const BATCH_STATUS_FAILURE = 'BATCH_STATUS_FAILURE';

export const IMAGE_RENDER = 'IMAGE_RENDER';

export const GET_PROPERTY_IMAGES_REQUEST = 'GET_PROPERTY_IMAGES_REQUEST';
export const GET_PROPERTY_IMAGES_SUCCESS = 'GET_PROPERTY_IMAGES_SUCCESS';
export const GET_PROPERTY_IMAGES_FAILURE = 'GET_PROPERTY_IMAGES_FAILURE';

export const IMAGE_DELETE_REQUEST = 'IMAGE_DELETE_REQUEST';
export const IMAGE_DELETE_SUCCESS = 'IMAGE_DELETE_SUCCESS';
export const IMAGE_DELETE_FAILURE = 'IMAGE_DELETE_FAILURE';

export const GET_CURRENCY_REQUEST = 'GET_CURRENCY_REQUEST';
export const GET_CURRENCY_SUCCESS = 'GET_CURRENCY_SUCCESS';
export const GET_CURRENCY_FAILURE = 'GET_CURRENCY_FAILURE';

export const GET_TIMEZONE_REQUEST = 'GET_TIMEZONE_REQUEST';
export const GET_TIMEZONE_SUCCESS = 'GET_TIMEZONE_SUCCESS';
export const GET_TIMEZONE_FAILURE = 'GET_TIMEZONE_FAILURE';

export const GET_STATE_REQUEST = 'GET_STATE_REQUEST';
export const GET_STATE_SUCCESS = 'GET_STATE_SUCCESS';
export const GET_STATE_FAILURE = 'GET_STATE_FAILURE';

export const GET_COUNTRY_REQUEST = 'GET_COUNTRY_REQUEST';
export const GET_COUNTRY_SUCCESS = 'GET_COUNTRY_SUCCESS';
export const GET_COUNTRY_FAILURE = 'GET_COUNTRY_FAILURE';

export const GET_LANGUAGES_REQUEST = 'GET_LANGUAGES_REQUEST';
export const GET_LANGUAGES_SUCCESS = 'GET_LANGUAGES_SUCCESS';
export const GET_LANGUAGES_FAILURE = 'GET_LANGUAGES_FAILURE';

export const GET_OTA_CODES_REQUEST = 'GET_OTA_CODES_REQUEST';
export const GET_OTA_CODES_SUCCESS = 'GET_OTA_CODES_SUCCESS';
export const GET_OTA_CODES_FAILURE = 'GET_OTA_CODES_FAILURE';

export const SAVE_PROPERTY_DETAILS_REQUEST = 'SAVE_PROPERTY_DETAILS_REQUEST';
export const SAVE_PROPERTY_DETAILS_SUCCESS = 'SAVE_PROPERTY_DETAILS_SUCCESS';
export const SAVE_PROPERTY_DETAILS_FAILURE = 'SAVE_PROPERTY_DETAILS_FAILURE';

export const SAVE_AND_PUBLISH_PROPERTY_DETAILS_REQUEST =
  'SAVE_AND_PUBLISH_PROPERTY_DETAILS_REQUEST';
export const SAVE_AND_PUBLISH_PROPERTY_DETAILS_SUCCESS =
  'SAVE_AND_PUBLISH_PROPERTY_DETAILS_SUCCESS';
export const SAVE_AND_PUBLISH_PROPERTY_DETAILS_FAILURE =
  'SAVE_AND_PUBLISH_PROPERTY_DETAILS_FAILURE';
export const IMAGE_SEARCH_REQUEST = 'IMAGE_SEARCH_REQUEST';
export const IMAGE_SEARCH_SUCCESS = 'IMAGE_SEARCH_SUCCESS';
export const IMAGE_SEARCH_FAILURE = 'IMAGE_SEARCH_FAILURE';

export const IMAGE_FILTER_REQUEST = 'IMAGE_FILTER_REQUEST';
export const IMAGE_FILTER_SUCCESS = 'IMAGE_FILTER_SUCCESS';
export const IMAGE_FILTER_FAILURE = 'IMAGE_FILTER_FAILURE';

export const IMAGE_SET_COVERIMAGE_REQUEST = 'IMAGE_SET_COVERIMAGE_REQUEST';
export const IMAGE_SET_COVERIMAGE_SUCCESS = 'IMAGE_SET_COVERIMAGE_SUCCESS';
export const IMAGE_SET_COVERIMAGE_FAILURE = 'IMAGE_SET_COVERIMAGE_FAILURE';

export const GET_HOTELS_REQUEST = 'GET_HOTELS_REQUEST';
export const GET_HOTELS_SUCCESS = 'GET_HOTELS_SUCCESS';
export const GET_HOTELS_FAILURE = 'GET_HOTELS_FAILURE';

export const DELETE_HOTEL_REQUEST = 'DELETE_HOTEL_REQUEST';
export const DELETE_HOTEL_SUCCESS = 'DELETE_HOTEL_SUCCESS';
export const DELETE_HOTEL_FAILURE = 'DELETE_HOTEL_FAILURE';

export const IMAGE_SET_EDITFILTER_REQUEST = 'IMAGE_SET_EDITFILTER_REQUEST';
export const IMAGE_SET_EDITFILTER_SUCCESS = 'IMAGE_SET_EDITFILTER_SUCCESS';
export const IMAGE_SET_EDITFILTER_FAILURE = 'IMAGE_SET_EDITFILTER_FAILURE';

export const UPDATE_PROPERTY_DETAILS_REQUEST =
  'UPDATE_PROPERTY_DETAILS_REQUEST';
export const UPDATE_PROPERTY_DETAILS_SUCCESS =
  'UPDATE_PROPERTY_DETAILS_SUCCESS';
export const UPDATE_PROPERTY_DETAILS_FAILURE =
  'UPDATE_PROPERTY_DETAILS_FAILURE';

export const IMAGE_AUTOENHANCE_REQUEST = 'IMAGE_AUTOENHANCE_REQUEST';
export const IMAGE_AUTOENHANCE_SUCCESS = 'IMAGE_AUTOENHANCE_SUCCESS';
export const IMAGE_AUTOENHANCE_FAILURE = 'IMAGE_AUTOENHANCE_FAILURE';

export const IMAGE_SET_TAGS_CAPTION_REQUEST = 'IMAGE_SET_TAGS_CAPTION_REQUEST';
export const IMAGE_SET_TAGS_CAPTION_SUCCESS = 'IMAGE_SET_TAGS_CAPTION_SUCCESS';
export const IMAGE_SET_TAGS_CAPTION_FAILURE = 'IMAGE_SET_TAGS_CAPTION_FAILURE';

export const GET_IMAGE_TAGS_REQUEST = 'GET_IMAGE_TAGS_REQUEST';
export const GET_IMAGE_TAGS_SUCCESS = 'GET_IMAGE_TAGS_SUCCESS';
export const GET_IMAGE_TAGS_FAILURE = 'GET_IMAGE_TAGS_FAILURE';

export const GET_PREVIEW_ON_SAVE_AND_PUBLISH_REQUEST =
  'GET_PREVIEW_ON_SAVE_AND_PUBLISH_REQUEST';
export const GET_PREVIEW_ON_SAVE_AND_PUBLISH_SUCCESS =
  'GET_PREVIEW_ON_SAVE_AND_PUBLISH_SUCCESS';
export const GET_PREVIEW_ON_SAVE_AND_PUBLISH_FAILURE =
  'GET_PREVIEW_ON_SAVE_AND_PUBLISH_FAILURE';

export const CONTENT_PUBLISH_REQUEST = 'CONTENT_PUBLISH_REQUEST';
export const CONTENT_PUBLISH_SUCCESS = 'CONTENT_PUBLISH_SUCCESS';
export const CONTENT_PUBLISH_FAILURE = 'CONTENT_PUBLISH_FAILURE';

export const CONTENT_PUBLISH_STATUS_REQUEST = 'CONTENT_PUBLISH_STATUS_REQUEST';
export const CONTENT_PUBLISH_STATUS_SUCCESS = 'CONTENT_PUBLISH_STATUS_SUCCESS';
export const CONTENT_PUBLISH_STATUS_FAILURE = 'CONTENT_PUBLISH_STATUS_FAILURE';

export const GET_WIZARD_DATA_REQUEST = 'GET_WIZARD_DATA_REQUEST';
export const GET_WIZARD_DATA_SUCCESS = 'GET_WIZARD_DATA_SUCCESS';
export const GET_WIZARD_DATA_FAILURE = 'GET_WIZARD_DATA_FAILURE';

export const GET_AUGMENTATION_REQUEST = 'GET_AUGMENTATION_REQUEST';
export const GET_AUGMENTATION_SUCCESS = 'GET_AUGMENTATION_SUCCESS';
export const GET_AUGMENTATION_FAILURE = 'GET_AUGMENTATION_FAILURE';

export const GET_DEMAND_PARTNERS_HOTEL_LIST_REQUEST =
  'GET_DEMAND_PARTNERS_HOTEL_LIST_REQUEST';
export const GET_DEMAND_PARTNERS_HOTEL_LIST_SUCCESS =
  'GET_DEMAND_PARTNERS_HOTEL_LIST_SUCCESS';
export const GET_DEMAND_PARTNERS_HOTEL_LIST_FAILURE =
  'GET_DEMAND_PARTNERS_HOTEL_LIST_FAILURE';

export const GET_ROOMS_REQUEST = 'GET_ROOMS_REQUEST';
export const GET_ROOMS_SUCCESS = 'GET_ROOMS_SUCCESS';
export const GET_ROOMS_FAILURE = 'GET_ROOMS_FAILURE';

export const IMAGE_ASSIGN_REQUEST = 'IMAGE_ASSIGN_REQUEST';
export const IMAGE_ASSIGN_SUCCESS = 'IMAGE_ASSIGN_SUCCESS';
export const IMAGE_ASSIGN_FAILURE = 'IMAGE_ASSIGN_FAILURE';

export const GET_ROOM_IMAGES_REQUEST = 'GET_ROOM_IMAGES_REQUEST';
export const GET_ROOM_IMAGES_SUCCESS = 'GET_ROOM_IMAGES_SUCCESS';
export const GET_ROOM_IMAGES_FAILURE = 'GET_ROOM_IMAGES_FAILURE';

export const ROOM_IMAGES_DELETE_REQUEST = 'ROOM_IMAGES_DELETE_REQUEST';
export const ROOM_IMAGES_DELETE_SUCCESS = 'ROOM_IMAGES_DELETE_SUCCESS';
export const ROOM_IMAGES_DELETE_FAILURE = 'ROOM_IMAGES_DELETE_FAILURE';

export const CREATE_PROPERTY_DETAILS_REQUEST =
  'CREATE_PROPERTY_DETAILS_REQUEST';
export const CREATE_PROPERTY_DETAILS_SUCCESS =
  'CREATE_PROPERTY_DETAILS_SUCCESS';
export const CREATE_PROPERTY_DETAILS_FAILURE =
  'CREATE_PROPERTY_DETAILS_FAILURE';

export const CREATE_DUPLICATE_HOTEL_REQUEST = 'CREATE_DUPLICATE_HOTEL_REQUEST';
export const CREATE_DUPLICATE_HOTEL_SUCCESS = 'CREATE_DUPLICATE_HOTEL_SUCCESS';
export const CREATE_DUPLICATE_HOTEL_FAILURE = 'CREATE_DUPLICATE_HOTEL_FAILURE';

export const CREATE_DUPLICATE_DASHBOARD_HOTEL_REQUEST =
  'CREATE_DUPLICATE_DASHBOARD_HOTEL_REQUEST';
export const CREATE_DUPLICATE_DASHBOARD_HOTEL_SUCCESS =
  'CREATE_DUPLICATE_DASHBOARD_HOTEL_SUCCESS';
export const CREATE_DUPLICATE_DASHBOARD_HOTEL_FAILURE =
  'CREATE_DUPLICATE_DASHBOARD_HOTEL_FAILURE';

export const GET_DEMAND_PARTNERS_ERROR_REQUEST =
  'GET_DEMAND_PARTNERS_ERROR_REQUEST';
export const GET_DEMAND_PARTNERS_ERROR_SUCCESS =
  'GET_DEMAND_PARTNERS_ERROR_SUCCESS';
export const GET_DEMAND_PARTNERS_ERROR_FAILURE =
  'GET_DEMAND_PARTNERS_ERROR_FAILURE';

export const GET_IMAGE_TOGGLE_REQUEST = 'GET_IMAGE_TOGGLE_REQUEST';
export const GET_IMAGE_TOGGLE_SUCCESS = 'GET_IMAGE_TOGGLE_SUCCESS';
export const GET_IMAGE_TOGGLE_FAILURE = 'GET_IMAGE_TOGGLE_FAILURE';

export const UPDATE_IMAGE_SCORE_REQUEST = 'UPDATE_IMAGE_SCORE_REQUEST';
export const UPDATE_IMAGE_SCORE_SUCCESS = 'UPDATE_IMAGE_SCORE_SUCCESS';
export const UPDATE_IMAGE_SCORE_FAILURE = 'UPDATE_IMAGE_SCORE_FAILURE';

export const GET_AUTOENHANCE_IMAGE_STATUS_REQUEST =
  'GET_AUTOENHANCE_IMAGE_STATUS_REQUEST';
export const GET_AUTOENHANCE_IMAGE_STATUS_SUCCESS =
  'GET_AUTOENHANCE_IMAGE_STATUS_SUCCESS';
export const GET_AUTOENHANCE_IMAGE_STATUS_FAILURE =
  'GET_AUTOENHANCE_IMAGE_STATUS_FAILURE';

export const MOVE_TO_PROPERTY_IMAGES_REQUEST =
  'MOVE_TO_PROPERTY_IMAGES_REQUEST';
export const MOVE_TO_PROPERTY_IMAGES_SUCCESS =
  'MOVE_TO_PROPERTY_IMAGES_SUCCESS';
export const MOVE_TO_PROPERTY_IMAGES_FAILURE =
  'MOVE_TO_PROPERTY_IMAGES_FAILURE';

export const GET_CONTACT_SUPPORT_DETAIL_REQUEST =
  'GET_CONTACT_SUPPORT_DETAIL_REQUEST';
export const GET_CONTACT_SUPPORT_DETAIL_SUCCESS =
  'GET_CONTACT_SUPPORT_DETAIL_SUCCESS';
export const GET_CONTACT_SUPPORT_DETAIL_FAILURE =
  'GET_CONTACT_SUPPORT_DETAIL_FAILURE';

export const SEND_CONTACT_SUPPORT_EMAIL_REQUEST =
  'SEND_CONTACT_SUPPORT_EMAIL_REQUEST';
export const SEND_CONTACT_SUPPORT_EMAIL_SUCCESS =
  'SEND_CONTACT_SUPPORT_EMAIL_SUCCESS';
export const SEND_CONTACT_SUPPORT_EMAIL_FAILURE =
  'SEND_CONTACT_SUPPORT_EMAIL_FAILURE';

export const GET_PUBLISH_REPORT_REQUEST = 'GET_PUBLISH_REPORT_REQUEST';
export const GET_PUBLISH_REPORT_SUCCESS = 'GET_PUBLISH_REPORT_SUCCESS';
export const GET_PUBLISH_REPORT_FAILURE = 'GET_PUBLISH_REPORT_FAILURE';
